import React from 'react';
import PropTypes from 'prop-types';

export default function HumanCoach({ score }) {
  return (
    <>
      <h2>Congratulations on Your Progress!</h2>

      <p>
        Your score:
        {score}
        {' '}
        points
      </p>
      <p>
        Based on your Health and Performance Assessment and AI coach debrief,
        we recommend taking the next step in your work readiness journey.
      </p>
      <h3>Build Your Personalized Program</h3>
      <p>
        Your results indicate you would benefit from a comprehensive approach
        with human coaching support to ensure a successful workplace reintegration.
      </p>
      <p>
        Our certified LeggUP coaches can help you:
        <ul>
          <li>Develop tailored strategies for your specific challenges</li>
          <li>Navigate complex workplace dynamics with confidence</li>
          <li>Create sustainable habits for long-term success</li>
        </ul>
      </p>

    </>
  );
}

HumanCoach.propTypes = {
  score: PropTypes.number.isRequired,
};
